import React from 'react';
import PropTypes from 'prop-types';

const EsignLandingPageBenefitsSection = props => (
  <React.Fragment>
    <div className="large-upload-panel-benefits-list">
      <div className="large-upload-panel-benefits-list-row">
        <div className="large-upload-panel-benefits-list-item">
          <img
            alt="Benefit Icon"
            className="large-upload-panel-benefits-list-item-icon"
            src="/images/pencil-icon.png"
          />
          <p
            className="large-upload-panel-benefits-list-item-text"
          >
            Easy to sign - just type, draw, or upload your signature
          </p>
        </div>
        <div className="large-upload-panel-benefits-list-item">
          <img
            alt="Benefit Icon"
            className="large-upload-panel-benefits-list-item-icon"
            src="/images/sign-arrow-icon.png"
          />
          <p
            className="large-upload-panel-benefits-list-item-text"
          >
            Request signatures from others in seconds
          </p>
        </div>
      </div>
      <div className="large-upload-panel-benefits-list-row">
        <div className="large-upload-panel-benefits-list-item">
          <img
            alt="Benefit Icon"
            className="large-upload-panel-benefits-list-item-icon"
            src="/images/share-icon.png"
          />
          <p
            className="large-upload-panel-benefits-list-item-text"
          >
            Status updates for you & automatic reminders for your signers
          </p>
        </div>
        <div className="large-upload-panel-benefits-list-item">
          <img
            alt="Benefit Icon"
            className="large-upload-panel-benefits-list-item-icon"
            src="/images/printer-icon.png"
          />
          <p
            className="large-upload-panel-benefits-list-item-text"
          >
            Secure and encrypted documents with a live audit trail
          </p>
        </div>
      </div>
    </div>
    <div className="large-upload-panel-testimonial-wrapper">
      <div className="large-upload-panel-testimonial-column no-border-xs">
        <p className="large-upload-panel-testimonial-large-text">1.2 million</p>
        <p className="large-upload-panel-testimonial-small-text">
          signing users
        </p>
      </div>
      <div className="large-upload-panel-testimonial-column no-border-md">
        <p className="large-upload-panel-testimonial-large-text">16 million</p>
        <p className="large-upload-panel-testimonial-small-text">
          documents signed
        </p>
      </div>
      <div className="large-upload-panel-testimonial-column press-logo-set">
        {props.isFullWidthUploadPanel ?
          <React.Fragment>
            <img
              alt="Press Icon TNW"
              className="large-upload-panel-testimonial-press-icon tnw-icon"
              src="/images/tnw-icon.png"
            />
            <img
              alt="Press Icon Inc"
              className="large-upload-panel-testimonial-press-icon inc-icon"
              src="/images/inc-icon.png"
            />
            <img
              alt="Press Icon Readwrite"
              className="large-upload-panel-testimonial-press-icon readwrite-icon"
              src="/images/readwrite-icon.png"
            />
            <img
              alt="Press Icon Huffington Post"
              className="large-upload-panel-testimonial-press-icon huff-post-icon"
              src="/images/huff-post-icon.png"
            />
          </React.Fragment>
          :
          <img
            alt="Press Icons"
            className="large-upload-panel-testimonial-press-icons"
            src="/images/press-logos-set.png"
          />
        }
      </div>
    </div>
  </React.Fragment>
);

EsignLandingPageBenefitsSection.defaultProps = {
  isFullWidthUploadPanel: false,
};

EsignLandingPageBenefitsSection.propTypes = {
  isFullWidthUploadPanel: PropTypes.bool,
};

export default EsignLandingPageBenefitsSection;



// WEBPACK FOOTER //
// ./src-react/EsignLandingPage/EsignLandingPageBenefitsSection.jsx